<template>
    <nuxt-link ref="bannerRef" :to="banner.url" class="banner">
        <div class="banner__container">
            <img class="banner__image" :src="banner.cdnImage" :alt="banner.title" />
            <span class="banner__info">
                <h2>{{ banner.title }}</h2>
                <p>{{ banner.description }}</p>
                <span class="btn btn-primary px-3 py-1 mt-4">{{ banner.cta }}</span>
            </span>
        </div>
    </nuxt-link>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import BannerTile from '~/models/Category/BannerTile'
import { useMatomoViewportTrack, useMatomoClickTrack } from '~/composables/useMatomo'

const props = defineProps({
    banner: {
        type: Object as PropType<BannerTile>,
        required: true,
    },
})

const bannerRef = ref<any | null>(null)

onMounted(() => {
    if (bannerRef.value.$el) {
        useMatomoViewportTrack(bannerRef.value.$el, {
            category: 'SubcategoryTileBanner',
            action: 'view',
            name: props.banner.title,
            value: parseInt(props.banner.id + ''),
        })

        useMatomoClickTrack(bannerRef.value.$el, {
            category: 'SubcategoryTileBanner',
            action: 'click',
            name: props.banner.title,
            value: parseInt(props.banner.id + ''),
        })
    }
})
</script>

<style lang="scss" scoped>
.banner {
    flex: 1;
    position: relative;
    color: $color-dark;

    &__container {
        display: block;
    }

    &__info {
        //background: #fff;
        height: 120%;
        width: 57%;
        //border-radius: 0 22% 63% 0/0 75% 100% 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        padding: 20px 15px 0;
        position: relative;

        h2 {
            font-size: 18px;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-line-clamp: 1;
            height: 23px;
            margin: 0 0 5px;
        }

        p {
            margin: 0;
            text-overflow: ellipsis;
            overflow: hidden;
            height: 50px;
        }
    }

    &__image {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        height: 100%;
        width: auto;
    }
}
</style>
